<template>
	<div data-tour-scope="setting-additional-tabs">
		<v-main>
			<v-container fluid>
				<v-row>
					<v-col cols="12">
						<v-card width="100%" outlined elevation-0>
							<v-toolbar flat class="border_bottom" shaped>
								<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.items.additionalTab') }} </v-toolbar-title>
								<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
								<v-spacer></v-spacer>
								<v-btn depressed color="primary" data-tour="add" @click="createItem"><v-icon left>mdi-plus</v-icon>Nuova tab</v-btn>
							</v-toolbar>


							<!-- telefono: ogni tab diventa una card con menu e switch come in tabella -->
							<div v-if="mobileCards" class="kv-list addtab-cards pa-3" data-tour="table">
								<key-value-card v-for="(item, index) of items" :key="item._id" :title="nomeTab(item)" :fields="campiCard(item)">
									<template v-slot:actions>
										<v-menu left eager>
											<template v-slot:activator="{ on, attrs }">
												<v-btn icon small v-bind="attrs" v-on="on" color="primary" :data-tour="index === 0 ? 'row-menu' : null">
													<v-icon> mdi-dots-vertical </v-icon>
												</v-btn>
											</template>
											<v-list>
												<v-list-item link @click="editItem(item._id)">
													<v-list-item-title class="size9">Modifica</v-list-item-title>
												</v-list-item>
												<v-list-item link @click="openDialogDelete(item)">
													<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
												</v-list-item>
											</v-list>
										</v-menu>
									</template>
									<div class="d-flex align-center justify-space-between">
										<span class="card-label">Attivo</span>
										<v-switch v-model="item.is_active" :data-tour="index === 0 ? 'switch' : null" @change="changeStatus(item._id)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
									</div>
								</key-value-card>
								<div v-if="!items.length" class="grey--text text-center py-4">Nessuna tab: aggiungila con "Nuova tab"</div>
							</div>
							<v-simple-table v-else data-tour="table">
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left" style="width: 40px"></th>
											<th class="text-left">Nome</th>
											<th class="text-left">Status</th>
											<th class="text-left">Posizione</th>
										</tr>
									</thead>
									<tbody>
										<tr v-if="!items.length">
											<td colspan="4" class="grey--text text-center">Nessuna tab: aggiungila con "Nuova tab"</td>
										</tr>
										<tr v-for="(item, index) of items" :key="item._id">
											<td class="pl-0 pr-0" style="width: 40px">
												<v-menu right eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon small v-bind="attrs" v-on="on" color="primary" :data-tour="index === 0 ? 'row-menu' : null">
															<v-icon> mdi-dots-vertical </v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link @click="editItem(item._id)">
															<v-list-item-title class="size9">Modifica</v-list-item-title>
														</v-list-item>
														<v-list-item link @click="openDialogDelete(item)">
															<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
											<td class="font-weight-medium">{{ nomeTab(item) }}</td>
											<td>
												<v-switch v-model="item.is_active" :data-tour="index === 0 ? 'switch' : null" @change="changeStatus(item._id)" color="primary" class="mt-0" hide-details></v-switch>
											</td>
											<td>{{ item.position }}</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-card>
					</v-col>
				</v-row>
			</v-container>

			<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
				<span v-html="snackbar.text"></span>
				<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
			</v-snackbar>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<CreateItem v-if="this.dialogCreate" @message="showSnackBar" @close="closeAllDialogs" :key="componentKey"></CreateItem>
			<EditItem v-if="this.dialogEdit" @message="showSnackBar" @close="closeAllDialogs" :id="selected" :key="componentKey"></EditItem>
		</v-dialog>

		<v-dialog v-model="dialogDelete" max-width="380">
			<v-card>
				<v-card-title class="headline">Eliminare la tab «{{ daEliminare ? nomeTab(daEliminare) : '' }}»?</v-card-title>
				<v-card-text>Non sarà più possibile ripristinarla.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogDelete = false"> Annulla </v-btn>
					<v-btn color="error" text @click="deleteItem"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import CreateItem from '../../components/additional_tabs/Create';
import EditItem from '../../components/additional_tabs/Edit';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createAdditionalTabsTourSteps } from './additional-tabs-tour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
export default {
	name: 'AdditionalTabs',
	components: { CreateItem, EditItem, TourOverlay, KeyValueCard },
	setup() {
		return { tour: useTour(createAdditionalTabsTourSteps()) };
	},
	beforeDestroy() {
		this.tour.stop();
	},
	data() {
		return {
			componentKey: 0,
			languages: [],
			lang: '',
			// tab in attesa di conferma nel dialog di eliminazione
			daEliminare: null,
			dialogCreate: false,
			dialogEdit: false,
			dialogDelete: false,
			items: [],
			selected: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
		};
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getDialog: 'settings/getDialog',
			getUrl: 'settings/getUrl',
			getSettings: 'settings/getSetting',
			getToken: 'profile/getToken',
		}),
	},
	async created() {
		this.setPreload(true);
		var profile = await this.fetchSettings();

		// Get Languages and Default Languages
		if (this.getSettings.languages !== undefined) {
			_.forEach(this.getSettings.languages, lang => {
				if (lang.is_active) {
					this.languages.push(lang.lang);

					if (lang.default) {
						this.lang = lang.lang;
					}
				}
			});
		}

		// Get Items
		if (this.getSettings.additional_tabs !== undefined) {
			_.forEach(this.getSettings.additional_tabs, item => {
				this.items.push(item);
			});
		}

		this.setPreload(false);
	},
	methods: {
		// coppie chiave/valore della card (vista telefono)
		campiCard(item) {
			return [{ label: 'Posizione', value: item.position }];
		},
		// nome nella lingua di default (o la prima disponibile)
		nomeTab(item) {
			const t = _.find(item.trans, { lang: this.lang }) || (item.trans || [])[0];
			return (t && t.name) || 'Tab';
		},
		...mapMutations({
			setPreload: 'settings/setPreload',
			setDialog: 'settings/setDialog',
			setLogout: 'profile/setLogout',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			setSettings: 'settings/updateData',
			updateSettings: 'settings/updateData',
		}),
		async createItem() {
			this.componentKey++;
			this.setDialog(true);
			this.dialogCreate = true;
		},
		async editItem(key) {
			this.selected = key;
			this.componentKey++;
			this.setDialog(true);
			this.dialogEdit = true;
		},
		async openDialogDelete(item) {
			this.daEliminare = item;
			this.selected = item._id;
			this.dialogDelete = true;
		},
		async deleteItem() {
			const items = _.filter(this.getSettings.additional_tabs, el => el._id !== this.selected);
			await this.saveItems(items);
			this.dialogDelete = false;
			this.daEliminare = null;
		},
		async changeStatus() {
			await this.saveItems(this.items);
		},
		async saveItems(items) {
			return new Promise((resolve, reject) => {
				items = _.orderBy(items, ['position'], ['asc']);

				let url = 'profile/product-additional-tab';
				this.setPreload(true);

				axios
					.post(`${this.getUrl}${url}`, items, { headers: { Authorization: `Bearer ${this.getToken}` } })
					.then(async ({ data }) => {
						this.showSnackBar('success', 'Operazione effettuata correttamente');

						await this.updateSettings(data.data);
						await this.refreshItems();
						this.setPreload(false);

						resolve(true);
					})
					.catch(err => {
						console.log(err.message);
						this.setPreload(false);

						if (err.response) {
							// gli errori del server vanno nella snackbar: in lista non ci sono campi su cui mostrarli
							let errors = err.response.data.error;
							const testo = Array.isArray(errors) ? errors.map(value => value.msg).join(' <br>') : err.message;

							this.showSnackBar('error', testo);

							if (err.response.status === 401) {
								this.setLogout();
								this.$router.push('/login');
							}
						}

						resolve(false);
					});
			});
		},
		async refreshItems() {
			this.items = [];
			if (this.getSettings.additional_tabs !== undefined) {
				_.forEach(this.getSettings.additional_tabs, item => {
					this.items.push(item);
				});

				this.items = _.orderBy(this.items, ['position'], ['asc']);
			}
		},
		showSnackBar(mode, message) {
			this.snackbar.color = mode;
			this.snackbar.text = message;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			if (mode === 'success') {
				this.refreshItems();
			}
		},
		closeAllDialogs() {
			this.dialogCreate = false;
			this.dialogEdit = false;
		},
	},
};
</script>

<style scoped>
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
